import React from "react";
import { CustomBreadcrumb } from "../../components";
import { PAY_BY_LINK_CONSTANTS } from "../../config/constants";
import { PayByLinkStyled } from "./styled";
import PayByLinkList from "./PayByLinkList";

const PayByLink = () => {
  return (
    <CustomBreadcrumb
      header={PAY_BY_LINK_CONSTANTS.HEADER}
      currentPage={PAY_BY_LINK_CONSTANTS.BREADCRUMB}
      isFromLandingPage={false}
    >
      <PayByLinkStyled>
        <PayByLinkList />
      </PayByLinkStyled>
    </CustomBreadcrumb>
  );
};

export default PayByLink;
